export class UpdateIntelligentActionContentResult {
    applicationId: string;
    ruleName: string;
    instanceId: number;
    resultStatus?: string;
    isCorrect?: boolean;
    content?: any;
    isAIGenerated?: boolean;
}